import React, { memo } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { device } from "theme/Breakpoints";

interface BannerItemProps {
  data: any;
}

const BannerItem: React.FC<BannerItemProps> = ({ data }) => {
  const imageUri = `data:${data.image.contentType};base64,${data.image.image}`;
  return (
    <Wrapper>
      {data.link && <LinkTo to={data.link} />}

      <ImageContainer src={imageUri} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: inherit;
  height: 250px;

  text-align: center;
  @media only screen and (${device.tablet}) {
    height: 300px;
  }
  @media only screen and (${device.laptop}) {
    height: 442px;
  }
`;

const LinkTo = styled(Link)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 2;
`;

const ImageContainer = styled.img`
  position: absolute;
  left: 50% !important;
  transform: translate(-50%, 0);
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media only screen and (${device.laptop}) {
    object-fit: cover;
    width: 100vw;
  }
`;

export default memo(BannerItem);
